var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"bg",attrs:{"fluid":""}},[_c('div',{staticClass:"app3d",attrs:{"id":"streetview"}}),_c('div',{attrs:{"id":"hotspot-info"}}),_c('div',{staticClass:"mini-mapf",attrs:{"id":"mini-map"}}),_c('div',{staticClass:"controlID"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"toanha"},[_c('div',{staticClass:"content-TN"},[_c('div',{staticClass:"content-toanha"},[_c('v-img',{staticClass:"img-toanha",attrs:{"src":require("../assets/SVG/toanha.svg")}})],1),_c('div',{staticClass:"list-btn",attrs:{"id":"list-btnnha"}},[_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 3 },staticStyle:{"bottom":"148px","left":"100px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_05',
                  3,
                  '05'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 3 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 4 },staticStyle:{"bottom":"163px","left":"425px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_05',
                  4,
                  '05'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 4 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 5 },staticStyle:{"bottom":"177px","left":"142px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_05',
                  5,
                  '05'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 5 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 6 },staticStyle:{"bottom":"191px","left":"465px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_05',
                  6,
                  '05'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 6 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 7 },staticStyle:{"bottom":"204px","left":"100px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_05',
                  7,
                  '05'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 7 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 8 },staticStyle:{"bottom":"218px","left":"425px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_10',
                  8,
                  '10'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 8 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 9 },staticStyle:{"bottom":"233px","left":"142px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_10',
                  9,
                  '10'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 9 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 10 },staticStyle:{"bottom":"245px","left":"465px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_10',
                  10,
                  '10'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 10 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 11 },staticStyle:{"bottom":"260px","left":"100px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_10',
                  11,
                  '10'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 11 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 12 },staticStyle:{"bottom":"273px","left":"425px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_10',
                  12,
                  '10'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 12 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 13 },staticStyle:{"bottom":"288px","left":"142px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_15',
                  13,
                  '15'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 13 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 14 },staticStyle:{"bottom":"301px","left":"465px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_15',
                  14,
                  '15'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 14 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 15 },staticStyle:{"bottom":"316px","left":"100px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_15',
                  15,
                  '15'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 15 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 16 },staticStyle:{"bottom":"330px","left":"425px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_15',
                  16,
                  '15'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 16 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 17 },staticStyle:{"bottom":"343px","left":"142px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_15',
                  17,
                  '15'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 17 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 18 },staticStyle:{"bottom":"356px","left":"465px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_20',
                  18,
                  '20'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 18 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 19 },staticStyle:{"bottom":"370px","left":"100px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_20',
                  19,
                  '20'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 19 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 20 },staticStyle:{"bottom":"384px","left":"425px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_20',
                  20,
                  '20'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 20 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 21 },staticStyle:{"bottom":"399px","left":"142px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_20',
                  21,
                  '20'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 21 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 22 },staticStyle:{"bottom":"412px","left":"465px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_20',
                  22,
                  '20'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 22 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 23 },staticStyle:{"bottom":"427px","left":"100px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_25',
                  23,
                  '25'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 23 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 24 },staticStyle:{"bottom":"440px","left":"425px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_25',
                  24,
                  '25'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 24 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 25 },staticStyle:{"bottom":"455px","left":"142px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_25',
                  25,
                  '25'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 25 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 27 },staticStyle:{"bottom":"489px","left":"100px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_25',
                  27,
                  '25'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 27 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 28 },staticStyle:{"bottom":"503px","left":"425px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_30',
                  28,
                  '30'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 28 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 29 },staticStyle:{"bottom":"518px","left":"142px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_30',
                  29,
                  '30'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 29 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 30 },staticStyle:{"bottom":"532px","left":"465px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_30',
                  30,
                  '30'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 30 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 31 },staticStyle:{"bottom":"546px","left":"100px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_30',
                  31,
                  '30'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 31 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 32 },staticStyle:{"bottom":"560px","left":"425px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_30',
                  32,
                  '30'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 32 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 33 },staticStyle:{"bottom":"573px","left":"142px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_35',
                  33,
                  '35'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 33 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 34 },staticStyle:{"bottom":"587px","left":"465px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_35',
                  34,
                  '35'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 34 ")]),_c('v-btn',{staticClass:"item-list-btn",class:{ ac: _vm.active_el == 35 },staticStyle:{"bottom":"601px","left":"100px"},on:{"click":function($event){return _vm.gotoview(
                  'apartment_' +
                    _vm.typei +
                    '_' +
                    _vm.optionanh +
                    '_' +
                    _vm.viewcurren +
                    '_FL_35',
                  35,
                  '35'
                )}}},[_c('span',{staticClass:"den"}),_vm._v(" 35 ")])],1)])]),_c('div',{staticClass:"text-center list-btn-control"},[_c('v-btn',{staticClass:"item-btn-control tower"},[_c('p',[_vm._v("Tower 1 - Apartment "+_vm._s(_vm.type))])]),_c('v-btn',{staticClass:"item-btn-control floor",class:{ active: _vm.isShow },on:{"click":function($event){_vm.isShow = !_vm.isShow;
            _vm.isFloor = !_vm.isFloor;}}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isShow),expression:"!isShow"}],staticClass:"item-img-control img-floor",attrs:{"src":require("../assets/floor.png")}}),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"item-img-control img-floor",attrs:{"src":require("../assets/floorb.png")}}),_c('p',[_vm._v("Floor "+_vm._s(_vm.floor))])]),_c('v-btn',{staticClass:"item-btn-control optionf",on:{"click":function($event){return _vm.optionanhf()}}},[_c('p',[(_vm.optionanh === 'sa')?_c('span',[_vm._v("Standard")]):_c('span',[_vm._v("Upgrade")])])]),_c('v-btn',{staticClass:"item-btn-control exit links",on:{"click":_vm.gotoApart}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.isExit),expression:"isExit"}],staticClass:"item-img-control img-exit",attrs:{"src":require("../assets/exit.png")}}),_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isExit),expression:"!isExit"}],staticClass:"item-img-control img-exit",attrs:{"src":require("../assets/exitb.png")}})])],1)]),_c('div',{staticClass:"nut",on:{"click":function($event){return _vm.goto360view('overview', 1)}}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"optionfl"},[_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 35 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_35',
            35,
            '35'
          )}}},[_vm._v(" 35 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 34 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_35',
            34,
            '35'
          )}}},[_vm._v(" 34 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 33 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_35',
            33,
            '35'
          )}}},[_vm._v(" 33 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 32 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_30',
            32,
            '30'
          )}}},[_vm._v(" 32 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 31 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_30',
            31,
            '30'
          )}}},[_vm._v(" 31 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 30 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_30',
            30,
            '30'
          )}}},[_vm._v(" 30 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 29 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_30',
            29,
            '30'
          )}}},[_vm._v(" 29 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 28 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_30',
            28,
            '30'
          )}}},[_vm._v(" 28 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 27 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_25',
            27,
            '25'
          )}}},[_vm._v(" 27 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 25 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_25',
            25,
            '25'
          )}}},[_vm._v(" 25 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 24 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_25',
            24,
            '25'
          )}}},[_vm._v(" 24 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 23 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_25',
            23,
            '25'
          )}}},[_vm._v(" 23 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 22 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_20',
            22,
            '20'
          )}}},[_vm._v(" 22 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 21 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_20',
            21,
            '20'
          )}}},[_vm._v(" 21 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 20 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_20',
            20,
            '20'
          )}}},[_vm._v(" 20 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 19 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_20',
            19,
            '20'
          )}}},[_vm._v(" 19 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 18 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_20',
            18,
            '20'
          )}}},[_vm._v(" 18 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 17 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_15',
            17,
            '15'
          )}}},[_vm._v(" 17 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 16 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_15',
            16,
            '15'
          )}}},[_vm._v(" 16 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 15 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_15',
            15,
            '15'
          )}}},[_vm._v(" 15 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 14 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_15',
            14,
            '15'
          )}}},[_vm._v(" 14 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 13 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_15',
            13,
            '15'
          )}}},[_vm._v(" 13 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 12 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_10',
            12,
            '10'
          )}}},[_vm._v(" 12 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 11 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_10',
            11,
            '10'
          )}}},[_vm._v(" 11 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 10 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_10',
            10,
            '10'
          )}}},[_vm._v(" 10 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 9 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_10',
            9,
            '10'
          )}}},[_vm._v(" 9 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 8 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_10',
            8,
            '10'
          )}}},[_vm._v(" 8 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 7 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_05',
            7,
            '05'
          )}}},[_vm._v(" 7 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 6 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_05',
            6,
            '05'
          )}}},[_vm._v(" 6 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 5 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_05',
            5,
            '05'
          )}}},[_vm._v(" 5 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 4 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_05',
            4,
            '05'
          )}}},[_vm._v(" 4 ")]),_c('v-btn',{staticClass:"opfl",class:{ ac: _vm.active_el == 3 },on:{"click":function($event){return _vm.gotoview(
            'apartment_' +
              _vm.typei +
              '_' +
              _vm.optionanh +
              '_' +
              _vm.viewcurren +
              '_FL_05',
            3,
            '05'
          )}}},[_vm._v(" 3 ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }